// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import ImageSearch20 from './ImageSearch20.tsx';
import ImageSearch24 from './ImageSearch24.tsx';

type ImageSearchProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    ImageSearch20,
    ImageSearch24,
};

const ImageSearch: FC<ImageSearchProps> = ({ variation, ...props }) => {
    const variationKey = `ImageSearch${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"ImageSearch" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default ImageSearch;
